var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.012,
    height: 14.074,
    viewBox: "0 0 15.012 14.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M14.543,17.867h-6.1V16.459a.468.468,0,0,0-.17-.361.461.461,0,0,0-.386-.1L.383,17.406A.468.468,0,0,0,0,17.867v10.32a.469.469,0,0,0,.383.461l7.506,1.407a.442.442,0,0,0,.086.008.469.469,0,0,0,.469-.469V28.187h6.1a.469.469,0,0,0,.469-.469V18.336A.469.469,0,0,0,14.543,17.867ZM6.451,24.595a.469.469,0,1,1-.706.617L4.382,23.654l-1.2,1.539a.47.47,0,0,1-.741-.577l1.308-1.681-1.29-1.475a.469.469,0,0,1,.706-.617L4.339,22.18l1.39-1.786a.469.469,0,1,1,.74.577L4.968,22.9Zm7.622,2.654H8.444v-.938H9.851a.469.469,0,1,0,0-.938H8.444v-.938H9.851a.469.469,0,1,0,0-.938H8.444v-.938H9.851a.469.469,0,1,0,0-.938H8.444v-.938H9.851a.469.469,0,1,0,0-.938H8.444V18.8h5.629Z",
    transform: "translate(0 -15.989)",
    fill: "#007f25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(11.259 3.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M385.407,144.011h-.938a.469.469,0,0,0,0,.938h.938a.469.469,0,0,0,0-.938Z",
    transform: "translate(-384 -144.011)",
    fill: "#007f25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(11.259 5.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M385.407,208.011h-.938a.469.469,0,0,0,0,.938h.938a.469.469,0,0,0,0-.938Z",
    transform: "translate(-384 -208.011)",
    fill: "#007f25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(11.259 7.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M385.407,272.011h-.938a.469.469,0,0,0,0,.938h.938a.469.469,0,0,0,0-.938Z",
    transform: "translate(-384 -272.011)",
    fill: "#007f25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(11.259 9.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M385.407,336.011h-.938a.469.469,0,0,0,0,.938h.938a.469.469,0,0,0,0-.938Z",
    transform: "translate(-384 -336.011)",
    fill: "#007f25"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/ExcelIcon.e4f85009380c2bacb468642baa8842d3.svg";
export { ForwardRef as ReactComponent };